// extracted by mini-css-extract-plugin
export default {"w1180":"index_w1180_mdp1u","h2wrapper":"index_h2wrapper_-nNIc"};